import React, { useState } from 'react'
import { Flex, TextVariant, Text, Wallet, RefreshIcon } from '@mprolab/uikit'
import { useWeb3React } from 'lib/wagmi-compat/useWeb3React'
import { isNil } from 'lodash'
import UseAnimations from 'react-useanimations'
import loading from 'react-useanimations/lib/loading'
import styled, { useTheme } from 'styled-components'

const RefreshWrapper = styled(Flex)<{ refresh: boolean }>`
  cursor: pointer;
  animation: ${({ refresh }) => (refresh ? 'rotation' : 'none')} 1s;
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }
`

interface BaseProps {
  description: string
  tokenBalance: string
  tokenTicker?: string
  tokensLoading?: boolean
}

interface WithRefreshBalance extends BaseProps {
  refreshBalance: () => Promise<void>
  hideRefresh?: never
}

interface WithHideRefresh extends BaseProps {
  hideRefresh: boolean
  refreshBalance?: never
}

type TokenAmountProps = WithRefreshBalance | WithHideRefresh

const TokenAmount: React.FC<TokenAmountProps> = ({
  description,
  tokenBalance,
  tokenTicker,
  refreshBalance,
  hideRefresh,
  tokensLoading
}) => {
  const { account } = useWeb3React()
  const [loadingBalance, setLoadingBalance] = useState(false)
  const { colors } = useTheme()

  const handleRefresh = async () => {
    if (typeof refreshBalance === 'function') {
      setLoadingBalance(true)
      await refreshBalance()
      setTimeout(() => {
        setLoadingBalance(false)
      }, 1000)
    }
  }
  const balanceLoading = tokensLoading || isNil(tokenBalance)

  const displayTokenAmount = () => {
    switch (true) {
      case !account:
        return <></>
      case balanceLoading:
        return (
          <Flex minWidth="40px" justifyContent="center">
            <UseAnimations animation={loading} size={14} strokeColor={colors.white3} />
          </Flex>
        )
      default:
        return (
          <Flex gap="8px" alignItems="center">
            <Wallet width={16} height={16} color={colors.gray3} />
            {loadingBalance ? (
              <Flex minWidth="40px" justifyContent="center">
                <UseAnimations animation={loading} size={14} strokeColor={colors.white3} />
              </Flex>
            ) : (
              <Text variant={TextVariant.TEXT_XS_BOLD} color={colors.gray3}>
                {isNil(tokenTicker) ? `${tokenBalance}` : `${tokenBalance} ${tokenTicker}`}
              </Text>
            )}
            {!hideRefresh && (
              <RefreshWrapper refresh={loadingBalance} onClick={handleRefresh}>
                <RefreshIcon />
              </RefreshWrapper>
            )}
          </Flex>
        )
    }
  }

  return (
    <Flex fullWidth justifyContent="space-between">
      <Text variant={TextVariant.TEXT_XS_BOLD}>{description}</Text>
      {displayTokenAmount()}
    </Flex>
  )
}

export default TokenAmount
